<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'properties.properties-parent-label' | translate }}"
      pageTitle="{{ 'properties.properties-title-label' | translate }}">
    </app-page-header>
  </div>
  <div class="row">
    <div class="col-lg-4 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <div class="form-fields-box" [ngClass]="!registerPropertiesBox ? 'closed' : ''"
          [formGroup]="createPropertiesForm">
          <h2 (click)="registerPropertiesOpen()">
            {{ "properties.form-register-label" | translate }}
          </h2>
          <hr [ngClass]="!registerPropertiesBox ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "properties.form-register-name" | translate
                }}</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "properties.form-register-source" | translate
                }}</mat-label>
              <input matInput formControlName="sourcename" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">3</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "properties.form-register-shortname" | translate
                }}</mat-label>
              <input maxlength="4" matInput formControlName="shortname" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">4</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "properties.form-register-service" | translate
                }}</mat-label>
              <input matInput formControlName="service" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">5</div>

            <mat-form-field class="parameter" appearance="outline">
              <mat-label>{{
                "properties.form-register-measurementUnit" | translate
                }}</mat-label>
              <mat-select formControlName="measurementUnitSelected" #value>
                @for (item of measurementUnitList; track item) {
                <mat-option [value]="item.id">
                  {{ item.name }} {{ item.symbol }}
                </mat-option>
                }

                @if (createLoading) {
                <mat-option>
                  <mat-spinner [diameter]="30"></mat-spinner>
                </mat-option>
                }

                @if (measurementUnitList.length === 0) {
                <mat-option>
                  Não há unidades de medidas cadastradas
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (!filterLoading) {
          <button (click)="createProperties()" class="btn btn-success">
            {{ "properties.form-button-save" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <div class="form-fields-box" [ngClass]="!filterPropertiesBox ? 'closed' : ''"
          [formGroup]="filterPropertiesForm">
          <h2 (click)="filterPropertiesOpen()">
            {{ "properties.form-filter-name" | translate }}
          </h2>
          <hr [ngClass]="!filterPropertiesBox ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "properties.form-register-name" | translate
                }}</mat-label>
              <input matInput formControlName="nameContains" />
            </mat-form-field>
          </div>

          @if (!filterLoading) {
          <button (click)="filterProperties(null)" class="btn btn-success">
            {{ "properties.form-button-filter" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    @if (ELEMENT_DATA.length) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading">
      </app-table-header>
      <!-- Sessão tabela -->
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name"> {{ "properties.column-name" | translate }}
              </th>
              <th pSortableColumn="sourceName">{{ "properties.column-source" | translate }}</th>
              <th pSortableColumn="shortName"> {{ "properties.column-shortname" | translate }}</th>
              <th pSortableColumn="service">{{ "properties.column-service" | translate }}</th>
              <th pSortableColumn="measurementUnit">{{ "properties.column-measurementUnit" | translate }}</th>
              <th pSortableColumn="actions">{{ "properties.column-actions" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.name}}</td>
              <td>{{row.sourceName}}</td>
              <td>{{row.shortName}}</td>
              <td>{{row.service}}</td>
              <td> {{ row.measurementUnit.name }}
                {{ row.measurementUnit.symbol }}</td>
              <td>
                <p-button styleClass="btn-actions" [rounded]="true" (click)="openSidebarUpdate(row, false)"
                  icon="pi pi-pen-to-square"></p-button>

                <p-button styleClass="btn-view" [rounded]="true" (click)="openSidebarUpdate(row, true)"
                  icon="pi pi-eye"></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>s
    </div>
    }
  </div>

  <!-- SideBar para edição/visualização -->
  @if (editorController) {
  <div class="sidebar-edit" [formGroup]="updatePropertiesForm">
    <mat-icon (click)="closeEditionSideBar()"> clear </mat-icon>
    @if (!viewController) {
    <h2> {{"properties.form-edit-property" | translate}}</h2>
    }
    @if (viewController) {
    <h2>Visualizar Propriedades</h2>
    }
    <hr />
    <mat-form-field appearance="outline">
      <mat-label>{{ "properties.form-edit-name" | translate }}
      </mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "properties.form-edit-source" | translate }}
      </mat-label>
      <input matInput formControlName="sourcename" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "properties.form-edit-shortname" | translate }}
      </mat-label>
      <input maxlength="4" matInput formControlName="shortname" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "properties.form-edit-service" | translate }}
      </mat-label>
      <input matInput formControlName="service" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>
        {{ "properties.form-edit-measurementUnit" | translate }}
      </mat-label>
      <mat-select formControlName="measurementUnitSelected" #value>

        @for (item of measurementUnitList; track item) {
        <mat-option [value]="item.id">
          {{ item.name }} {{ item.symbol }}
        </mat-option>
        }

        @if (updateLoading) {
        <mat-option>
          <mat-spinner [diameter]="30"></mat-spinner>
        </mat-option>
        }

        @if (measurementUnitList.length === 0) {
        <mat-option>
          {{"properties.no-measurementUnit" | translate}}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (!viewController) {
    <button class="btn btn-success" (click)="updateProperties()">
      {{"properties.button-edit" | translate}}
    </button>
    }
  </div>
  }
</div>